<template>
  <div id="qrCode">
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCode',
  props: {
    link: {
      type: String,
      required: true,
      default: 'http://www.maikeji.cn'
    }
  },
  components: {
    QRCode: QRCode
  },
  mounted () {
    this.useqrcode()
  },
  methods: {
    useqrcode () {
      const canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, this.link, function (error) {
        if (error) this.$message.error(`生成二维码出错：${error}`)
      })
    }
  }
}
</script>

<style scoped>
</style>
